<template lang="html">
    <div class="section section-black py-5">
        <div class="container text-center">
            <h3 class="mb-4">Promotie <b>Cont Premium</b> pentru fotografi si videografi</h3>
            <div class="mb-4">
                Pe întreaga perioadă de afișare a rezultatelor Concursului Anual, toți membrii catalogului pot activa Contul Premium la <b>preț redus</b>. <a href="https://www.fotografi-cameramani.ro/admin_membru/video/cont_premium" target="_blank">Intră în contul tău</a> și beneficiază de promoție!
            </div>
            <a href="https://www.fotografi-cameramani.ro/admin_membru/video/cont_premium" target="_blank" class="btn btn-lg btn-primary">Cumpara <b>Cont Premium</b> la <b>pret redus</b></a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PromoMembers',
    components: {
    },
    props: {
    },
    computed: {
    },
    data: function() {
        return {}
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>

</style>
